/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listSshKeySignedEvents = /* GraphQL */ `
  query listSshKeySignedEvents(
    $token: String
    $limit: Int
  ) {
    listSshKeySignedEvents( nextToken: $token, limit: $limit ){
      sshKeySignedEvents{
          id
          username
          requestedAt: raisedOn
          publicKey
          raisedBy
          validUntil
          publicKey
          signedKey
      }
      nextToken
      previousToken
    }
  }
`;
